import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppPages } from '@constants/app-pages';
import { ReservaService } from '@infra/reserva/reserva.service';
import { InitializationService } from '@infra/initialization/initialization.service';
import { AuthService } from '@infra/auth/auth.service';
@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],
})
export class BaseComponent implements OnInit {
  showToolbar = false;
  isLoading: boolean = false;
  requestError: boolean = false;
  logo = sessionStorage.getItem('urlLogo') || '';
  paramsReserva: any;
  routerSessionStorage: string = '';
  routerPortalReservas: string = '';

  constructor(
    private router: Router,
    private _routerActivate: ActivatedRoute,
    public reservaService: ReservaService,
    public authService: AuthService,
    public initializationService: InitializationService
  ) {
    this._routerActivate.queryParams.subscribe((params) => {
      this.paramsReserva = params;
      this.routerPortalReservas = params['Router'];
      if (this.routerPortalReservas) {
        this.routerSessionStorage = this.routerPortalReservas;
        sessionStorage.setItem('Router', this.routerSessionStorage);
      }
    });
  }

  ngOnInit() {
    this.isLoading = true;
    const routerSessionStorage = sessionStorage.getItem('Router');
    if (routerSessionStorage) {
      this.initializationService.initialize(routerSessionStorage).then(
        (result) => {
          if (result.Router) {
            this.isLoading = false;
            this.logo = result.urlLogo;
            this.router.navigateByUrl(AppPages.HOME, { replaceUrl: true });
          } else {
            this.isLoading = false;
            this.requestError = true;
            sessionStorage.clear();
          }
        },
        (error) => {
          this.isLoading = false;
          this.requestError = true;
          sessionStorage.clear();
        }
      );
    } else {
      this.initializationService.initialize(this.routerPortalReservas).then(
        (result) => {
          if (result.Router) {
            this.isLoading = false;
            this.logo = result.urlLogo;
            this.router.navigateByUrl(AppPages.HOME, { replaceUrl: true });
          } else {
            this.isLoading = false;
            this.requestError = true;
            sessionStorage.clear();
          }
        },
        (error) => {
          this.isLoading = false;
          this.requestError = true;
          sessionStorage.clear();
        }
      );
    }
  }

  goToHome() {
    this.router.navigateByUrl(AppPages.HOME);
  }
}
